import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ApiConfiguration, StateService, ToolService } from '../../public-api';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
@Component({
  selector: 'lib-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss'],
  standalone: false,
})
export class ViewerComponent implements OnInit {
  docContentPage: number = 1;
  @ViewChild('viewerContainer', { static: true })
  viewerContainer: ElementRef<HTMLDivElement>;
  pdfjsIframe: HTMLIFrameElement;
  @Input() docId: string;
  @Input() pdfType: string;
  @Input() fileExtension: string;
  @Input() docName: string;
  isPdf: boolean = false;
  isImage: boolean = false;
  isVideo: boolean = false;
  imageExtensions: string[] = ['.jpg', '.jpeg', '.png'];
  hideLoader: boolean = false;
  loader: HTMLIonLoadingElement;
  localUrl: string;
  file: Blob;
  constructor(
    private base: ApiConfiguration,
    public state: StateService,
    private tools: ToolService
  ) {}

  async ngOnInit() {
    window.addEventListener('message', async (event: MessageEvent) => {
      if (event.data?.type === 'documentloaded') {
        this.loader?.dismiss();
        this.loader?.dismiss();
      }
      if (event.data?.type === 'documentdownload') {
        console.log('download');
        await this.downloadFile();
      }
    });
    this.isPdf = this.fileExtension.toLowerCase() == '.pdf';
    this.isImage = this.imageExtensions.includes(
      this.fileExtension.toLowerCase()
    );
    this.isVideo = this.fileExtension.toLowerCase() == '.mp4';
    if (this.isPdf && this.pdfType != 'document') {
      this.loader = await this.tools.showLoader('Bericht wird generiert');
      this.loader.present();
    }
    this.state.downloadBinary(this.docId, this.pdfType).subscribe({
      next: async (x) => {
        this.file = x;
        this.localUrl = URL.createObjectURL(x);
        if (this.isPdf) {
          if (this.pdfType == 'document') {
            this.loader = await this.tools.showLoader('Dokument wird geladen');
            this.loader.present();
          }
          this.loadPdfJs();
        }
      },
      error: (err) => {
        this.state.handleError(err);
      },
    });
  }

  loadPdfJs(): void {
    const iFrame = document.createElement('iframe');
    iFrame.style.width = '100%';
    iFrame.style.height = '100%';
    iFrame.style.border = 'none';

    iFrame.src = `/assets/pdfjs/web/viewer.html?file=${encodeURIComponent(
      this.localUrl
    )}&filename=${encodeURIComponent(this.docName)}`;

    this.viewerContainer.nativeElement.appendChild(iFrame);
    this.pdfjsIframe = iFrame;
  }

  loadNative() {
    const iFrame = document.createElement('iframe');
    iFrame.style.width = '100%';
    iFrame.style.height = '100%';
    iFrame.style.border = 'none';
    iFrame.allowFullscreen = true;
    iFrame.src = `${this.getFileSource()}`;

    this.viewerContainer.nativeElement.appendChild(iFrame);
  }

  getFileSource(): string {
    return this.docId
      ? `${this.base.rootUrl}/api/v0/binary/${this.pdfType}/${this.docId}/content`
      : '';
  }

  getFileVideoSource(): string {
    return this.docId
      ? `${this.base.rootUrl}/api/v0/binary/${this.pdfType}/${this.docId}/content`
      : '';
    // add #t=0.1
  }

  //hopefully this feature can be deleted and the capacitor/share package uninstalled when pdf annotations are working
  async downloadFile() {
    const base64Data = await this.tools.blobToBase64(this.file);

    const result = await Filesystem.writeFile({
      path: this.docName + this.fileExtension,
      data: base64Data,
      directory: Directory.Documents,
    });

    if (this.state.isIOS) {
      const shareResult = await Share.share({
        title: this.docName + this.fileExtension,
        url: result.uri,
      });
    } else {
      if (result && result.uri) {
        await this.tools.showInfoToast(
          'Datei erfolgreich in den Dokumenten abgelegt'
        );
      } else {
        await this.tools.showErrorToast(
          'Beim Speichern der Datei ist etwas schiefgelaufen: ' +
            JSON.stringify(result)
        );
      }
    }
  }
}
